import { render, staticRenderFns } from "./CountStatsChart.vue?vue&type=template&id=c8e3924e&"
import script from "./CountStatsChart.vue?vue&type=script&lang=js&"
export * from "./CountStatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports